import { render } from "./MMAMonthNews.vue?vue&type=template&id=45811f68"
import script from "./MMAMonthNews.vue?vue&type=script&lang=js"
export * from "./MMAMonthNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__